import { MediaContentShowcaseItem } from "onnit-ui/lib/module/MediaContentShowcase";

const mushroomBlend: MediaContentShowcaseItem[] = [
    {
        image: `cordyseps-cutout.png`,
        imageWidth: 560,
        imageHeight: 560,
        title: 'Organic Cordyceps',
        summary:
            'A mushroom that grows at high altitudes and is popular in Traditional Chinese Medicine.',
        detail: 'Research indicates that cordyceps helps support energy utilization during exercise.<span class="oui-sup">&dagger;</span>'
    },
    {
        image: `Reishi-cutout.png`,
        imageWidth: 560,
        imageHeight: 560,
        title: 'Organic Reishi',
        summary:
            'Known as "the herb of spiritual potency" in China, reishi is a mushroom that symbolizes success, well-being and longevity in Asia.<span class="oui-sup">&dagger;</span>',
        detail: 'May help support the immune system.<span class="oui-sup">&dagger;</span>'
    },
    {
        image: `lionsmane-cutout.png`,
        imageWidth: 560,
        imageHeight: 560,
        title: 'Organic Lion’s Mane',
        summary:
            'A shaggy-shaped mushroom that resembles its namesake, lion’s mane is often used in recipes for its seafood-like flavor.',
        detail: 'Studies suggest lion’s mane can help support the brain cells and contribute to healthy cognitive function.<span class="oui-sup">&dagger;</span>'
    }
];

export default mushroomBlend;
